import { checkProtected } from './App'

const { AppRoutingRoles } = require('router/RoleBasedAccess')

export const getAuthorizedRoutes = (navList, loggedIn, role) => {
    return navList.filter((link) =>
        checkProtected(
            AppRoutingRoles[link.route].isProtected,
            loggedIn,
            role,
            AppRoutingRoles[link.route].checkRoles
        )
    )
}
